import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-content-loader',
	templateUrl: './loading.component.html',
})
export class LoadingComponent {
	@Input() loading: boolean;
	@Input() size?: string;
}
